import { actionsStyles } from "@insite/content-library/Widgets/ProductList/ProductListTable";
import { css } from "styled-components";

actionsStyles.actionsHeader = {
    css: css`
        position: sticky;
        right: 0;
        background-clip: padding-box;
    `,
};

actionsStyles.availabilityCell = {
    css: css`
        white-space: normal;
        div[data-test-selector="availabilityMessageWrapper"] {
            justify-content: flex-start;
        }
    `,
};

actionsStyles.actionsCell = {
    css: css`
        position: sticky;
        right: 0;
        background-color: inherit;
        background-clip: padding-box;
    `,
};
